import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "@/context/useUser";

interface RoleGuardProps {
    allowedRoles: number[];
    children?: React.ReactNode;
}

export default function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
    const { data: user, isLoading } = useUser();

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (!user || !allowedRoles.includes(user.role_id)) {
        return <Navigate to="/dashboard" replace />;
    }

    return children ? <>{children}</> : <Outlet />;
}